import script from "./ContestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestsPage.vue?vue&type=script&setup=true&lang=js"

import "./ContestsPage.vue?vue&type=style&index=0&id=5646f539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5646f539"]])

export default __exports__